import { APP_VERSION } from './config';

/**
 * Periodically polls /api/app-version and reloads the page when the
 * server's reported version differs from the bundle's compile-time
 * version (§2.11).
 */
export function startVersionWatcher(intervalMs: number): () => void {
  let stopped = false;
  let timer: ReturnType<typeof setTimeout> | null = null;

  const tick = async (): Promise<void> => {
    if (stopped) return;
    try {
      const res = await fetch('/api/app-version');
      if (res.ok) {
        const body = (await res.json()) as { version?: string };
        if (body.version && body.version !== APP_VERSION) {
          window.location.reload();
          return;
        }
      }
    } catch {
      /* transient - try again next interval */
    }
    timer = setTimeout(() => void tick(), intervalMs);
  };

  timer = setTimeout(() => void tick(), intervalMs);

  return () => {
    stopped = true;
    if (timer) clearTimeout(timer);
  };
}
